import { createContext, useCallback } from 'react';
import { createPropsContextProvider } from '../../utils/createPropsContextProvider.js';
import { createUseDefinedContext } from '../../utils/hooks/createUseDefinedContext.js';
const context = createContext(undefined);
export const ListSelectionProvider = createPropsContextProvider(context);
export const useListSelectionContext = createUseDefinedContext(context, 'useListSelectionContext requires ListSelectionContext to read list item properties');
export const useListSelection = (id) => {
    const { onClick, selectedId, focusedId } = useListSelectionContext();
    const isSelected = selectedId === id;
    const isFocused = focusedId === id;
    const onClickInjected = useCallback(() => onClick(id), [id, onClick]);
    return { isSelected, isFocused, onClick: onClickInjected };
};
//# sourceMappingURL=ListSelectionProvider.js.map